/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSidebar = {
  init: function() {

    const facetedFilterForm = document.querySelector('[data-faceted-filter-form]')
    if (facetedFilterForm) {
      facetedFilterForm.addEventListener('change', e => {
        if (e.target.type == 'number') return;
        facetedFilterForm.submit();
      });
    }

    const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');

    openSidebarBlocks.forEach(function(block){
      Shopify.theme.jsSidebar.openSidebarBlock($(block));
    })


    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {

      e.preventDefault();
      Shopify.theme.jsSidebar.openSidebarBlock($(this));
    });

    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function(e) {

      e.preventDefault();
      Shopify.theme.jsSidebar.closeSidebarBlock($(this));
    });

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');

    }

    // Collection sidebar price range
    $(document).ready(function () {
      var priceRangeArea = document.querySelector('.priceRangeAreaList');
      if (!priceRangeArea || !priceRangeArea.hasAttribute('data-applied-range')) {
        localStorage.removeItem('minProdVal');
        localStorage.removeItem('maxProdVal');
      }

      var storedMinPrice = localStorage.getItem('minProdVal');
      var storedMaxPrice = localStorage.getItem('maxProdVal');

      var minCollectionPrice = storedMinPrice ? parseFloat(storedMinPrice) : parseFloat($("#minProdVal").val());
      var maxCollectionPrice = storedMaxPrice ? parseFloat(storedMaxPrice) : parseFloat($("#maxProdVal").val());
      
      const maxCollectionPriceInArray = $("#maxProdVal").val();
      const valuesForSlider = [];
      for (let i = 1; i <= maxCollectionPriceInArray; i++) {
        valuesForSlider.push(i);
      }

      var rangeSlider = document.getElementById("priceRangeSlider");
      var moneyFormat = wNumb({
        decimals: 0,
        thousand: ",",
        prefix: "$",
      });

      noUiSlider.create(rangeSlider, {
        start: [minCollectionPrice, maxCollectionPrice],
        step: 1,
        range: { min: 0, max: valuesForSlider.length },
        format: moneyFormat,
        connect: true,
      });

      rangeSlider.noUiSlider.on("update", function (values, handle) {
        document.getElementById("slider-value-min").innerHTML = values[0];
        document.getElementById("slider-value-max").innerHTML = values[1];

        $("#minProdVal").val(moneyFormat.from(values[0]));
        $("#maxProdVal").val(moneyFormat.from(values[1]));

        localStorage.setItem('minProdVal', moneyFormat.from(values[0]));
        localStorage.setItem('maxProdVal', moneyFormat.from(values[1]));

        console.log(moneyFormat.from(values[0]));
        console.log(moneyFormat.from(values[1]));
      });

      var urlParams = new URLSearchParams(window.location.search);
      var urlMinPrice = urlParams.get('min_price');
      var urlMaxPrice = urlParams.get('max_price');

      if (urlMinPrice && urlMaxPrice) {
        minCollectionPrice = parseFloat(urlMinPrice);
        maxCollectionPrice = parseFloat(urlMaxPrice);
        rangeSlider.noUiSlider.set([minCollectionPrice, maxCollectionPrice]);
      }
    });

  },
  openSidebarBlock: function ($toggleBtn) {

    const $parentBlock = $toggleBtn.closest('.sidebar__block');
    const $toggleIcon = $toggleBtn.find('.icon');

    $toggleBtn.attr('data-sidebar-block__toggle', 'open');

    $parentBlock.addClass('is-active');
    $parentBlock.attr('aria-expanded', true);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideDown();
  },
  closeSidebarBlock: function ($toggleBtn) {

    const $parentBlock = $toggleBtn.closest('.sidebar__block');
    const $toggleIcon = $toggleBtn.find('.icon');

    $toggleBtn.attr('data-sidebar-block__toggle', 'closed');

    $parentBlock.removeClass('is-active');
    $parentBlock.attr('aria-expanded', false);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideUp();
  },
  unload: function() {
    const $toggleBtn = $('[data-sidebar-block__toggle]');
    $toggleBtn.off();
  }
}

/******/ })()
;